const serialize = (value: Record<string, unknown> | string | unknown, formData: FormData, parentKey = '') => {
  if (Array.isArray(value)) {
    value.forEach((item, index) => serialize(item, formData, parentKey + `[${index}]`));
  } else if (typeof value === 'object' && value?.constructor?.name !== 'File' && value?.constructor?.name !== 'Blob') {
    for (const key in value) {
      serialize((value as Record<string, unknown>)[key], formData, parentKey + key);
    }
  } else {
    formData.append(parentKey, value as string);
  }
};

/**
 * Serializes object to API-compatible FormData
 */
export const toFormData = (object: Record<string, unknown>): FormData => {
  const formData = new FormData();
  serialize(object, formData);
  return formData;
};
